import { render, staticRenderFns } from "./biographical.vue?vue&type=template&id=2a08ca15"
import script from "./biographical.vue?vue&type=script&lang=js"
export * from "./biographical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports